import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import useToast from 'hooks/useToast';
import useAnalytics from 'hooks/useAnalytics';
import { MIXPANEL_EVENTS } from 'constants/constants';
import { replaceError } from 'utils/helpers';
import { reportEvent } from 'state/actions/eventActions';

export default () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const { status, error } = useStatus(reportEvent);

  const { showErrorToast, showToast } = useToast();

  useEffect(() => {
    if (status === SUCCESS) {
      trackEvent(MIXPANEL_EVENTS.reportEvent);
      showToast('The content was successfully reported!');
      dispatch(reportEvent.reset());
    }
    if (status === ERROR) {
      showErrorToast(replaceError(error, /^reason /));
      dispatch(reportEvent.reset());
    }
  }, [dispatch, showErrorToast, showToast, status, error]);

  return useCallback(({ eventId, params }) => dispatch(reportEvent({ eventId, params })), [
    dispatch
  ]);
};
